module.exports = __webpack_public_path__ + "static/media/semitendinosus_left_weak.2a278d59.png";